import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export function useTranslationWrapper(nameSpace = 'translations') {
  const { t: tFunction } = useTranslation(nameSpace);
  const t = useCallback(
    (key, params) => {
      return tFunction(key, params);
    },
    [tFunction]
  );

  return { t };
}
